import { moduleProviderFactory } from "core/providers";
import { DocumentationRequestEmailEdit } from "application/documentation-request/pages";

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: "master.app.main.facility-order",
				pattern: "/facility-orders",
                children: [
                    {
                        name: "master.app.main.facility-order.documentation-request.edit-email",
                        pattern: "/:facilityOrderId/documentation-request",
                        component: DocumentationRequestEmailEdit,
                        data: {
                            crumbs: [
                                {
                                    title: "FACILITY_ORDER.CRUMB.TEMPLATES",
                                    route: 'master.app.main.facility-order.facility-order-template.list'
                                },
                                {
                                    title: "DOCUMENTATION_REQUEST.TITLE",
                                    route: 'master.app.main.facility-order.documentation-request.edit-email'
                                }
                            ]
                        }
                    },                 
                ]
            }
        ],
        menu: [
            {
				title: "MENU.FACILITY_ORDERS",
				icon: "package",
				authorization: "coreUserSection.read",
				order: 5,
				subMenu: [
					{
						title: "MENU.FACILITY_ORDERS_SUB_DAVID",
						authorization: "facilityOrderSection.read",
						route: "master.app.main.facility-order.list",
						order: 1,
					}  
				]
			},
        ]
    });
})();
